import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import PendingTasks from 'pages/cs/pending-tasks';
import Reviews from 'pages/cs/reviews';
import Search from 'pages/search';
import SearchResult from 'pages/search/search-results';
import CreateOrder from 'pages/cs/create-order';
import LiveTrips from 'pages/live-trips';
import Profile from 'pages/cs/settings/profile';
import Banks from 'pages/cs/settings/banks';
import CSReps from 'pages/cs/settings/cs-reps';
import { CS_ROUTE_KEYS } from 'utils/constants';
import SettingsLayout from 'pages/cs/settings/layout';
import SettingsIndex from 'pages/cs/settings';
import Password from 'pages/cs/settings/password';
import RepDetails from 'pages/cs/settings/cs-reps/cs-rep-details';
import CsTeamStats from 'pages/cs/cs-team-stats';
import DashboardLayout from 'layouts/dashboard.layout';
import { getInitialRoute } from 'utils/role-config';
import UserProfile from 'pages/user';
import RecalledOrders from 'pages/recalled-orders';
import ClearLocalStorage from 'pages/clear-local-storage';
import TaskHistory from 'pages/task-history';
import UpdateOrderDetails from 'pages/order-details/udpate-order-details';

const SETTINGS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <SettingsIndex />
  },

  {
    path: CS_ROUTE_KEYS.BANKS,
    element: <Banks />
  },
  {
    path: CS_ROUTE_KEYS.PROFILE,
    element: <Profile />
  },
  {
    path: CS_ROUTE_KEYS.PASSWORD,
    element: <Password />
  },
  {
    path: CS_ROUTE_KEYS.CS_REPS,
    element: <CSReps />
  }
];
const CS_CHILD_ROUTES: RouteObject[] = [
  {
    path: CS_ROUTE_KEYS.DASHBOARD,
    element: <Navigate to={getInitialRoute()} />
  },
  {
    path: CS_ROUTE_KEYS.PENDING_TASKS,
    element: <PendingTasks />
  },
  {
    path: CS_ROUTE_KEYS.CLEAR_STORAGE,
    element: <ClearLocalStorage />
  },
  {
    path: CS_ROUTE_KEYS.REVIEWS,
    element: <Reviews />
  },
  {
    path: CS_ROUTE_KEYS.SEARCH,
    element: <Search />
  },
  {
    path: CS_ROUTE_KEYS.SEARCH_RESULT,
    element: <SearchResult />
  },
  {
    path: CS_ROUTE_KEYS.TEAM_STATS,
    element: <CsTeamStats />
  },
  {
    // TODO :: confirm flow from Rinsola
    path: CS_ROUTE_KEYS.NEW_ORDER,
    element: <CreateOrder />
  },
  {
    path: CS_ROUTE_KEYS.UPDATE_ORDER,
    element: <UpdateOrderDetails />
  },
  {
    path: CS_ROUTE_KEYS.SETTINGS,
    element: <SettingsLayout />,
    children: SETTINGS_ROUTES
  },
  {
    path: CS_ROUTE_KEYS.LIVE_TRIPS,
    element: <LiveTrips />
  },
  {
    path: CS_ROUTE_KEYS.TASK_HISTORY,
    element: <TaskHistory />
  },
  {
    path: CS_ROUTE_KEYS.RECALLED_ORDERS,
    element: <RecalledOrders />
  },
  {
    path: CS_ROUTE_KEYS.CS_REPS_INFO,
    element: <RepDetails />
  },
  {
    path: CS_ROUTE_KEYS.USER_PROFILE,
    element: <UserProfile />
  }
];

export const CS_ROUTES: RouteObject[] = [
  {
    path: CS_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: CS_CHILD_ROUTES
  }
];
